import React from "react";

import MainHero from "components/common/main-hero/main-hero";
import InfoSection from "./components/info-section/info-section";
import ValueSection from "./components/values-section/value-section";

import { PageHead } from "utils/page-head";
import { TITLE } from "constant/app.page-title";

const AboutUs = () => {
  return (
    <>
      <PageHead title={TITLE.ABOUT_US} />

      <MainHero
        heroDescription="We are a team inspired To be better"
        heroName="About us"
        heroTitle="ABOUT"
      />
      <InfoSection />
      <ValueSection />
    </>
  );
};

export default AboutUs;
